var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0a4b5bf7!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./btn-loader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/plugin/components/btn-loader.vue
// module id = 62
// module chunks = 0